@if (loading) {
  <tp-spinner></tp-spinner>
} @else if (reauthRequired) {
  <tp-reauthenticate
    reauthAction="set up multi-factor authentication"
    [isSubmitting$]="isSubmitting$"
    (reauthStageChanged)="reauthStageChanged($event)"
  ></tp-reauthenticate>
} @else {
  <p>Scan the QR Code below using your preferred authenticator app (e.g. Google Authenticator, Microsoft Authenticator, etc) and then enter the provided code below. </p>
  @if (mfaSession$ | async; as mfaSession) {
    <div class="qrcode-container">
      <qrcode
        [qrdata]="mfaSession.qrCodeUrl"
        colorLight="#dedede"
        colorDark="#151322"
      ></qrcode>
    </div>
    @if (!showSecretKey) {
      <tp-button buttonId="showMFASecretKey" (click)="showSecretKey = true" buttonStyle="secondary">Can't scan the QR code?</tp-button>
    } @else {
      @if (userEmail$ | async; as userEmail) {
        <p>Enter the following information into your authenticator app:</p>
        <strong>Account:</strong>
        <p>{{ userEmail }}</p>
        <strong>Secret Key:</strong>
        <p>{{ mfaSession.secretKey }}</p>
      }
    }
  } @else {
    <tp-spinner></tp-spinner>
  }
  <br/>
  <tp-form [formGroup]="otpForm" [isSubmitting$]="isSubmitting$" (doSubmit)="submitOTP()">
    <div [class.otp-code-row-single-line]="!cancellable">
      <tp-form-input type="text" [form]="otpForm" field="mfaCode" label="MFA code" />
      <tp-form-actions
        [height]="cancellable ? 40 : 44"
        [cancellable]="cancellable" [submitDisabled]="!otpForm.dirty" submitText="Confirm" [isSubmitting]="isSubmitting$ | async"
        buttonIdPrefix="setupMFAModal" (cancel)="cancel.emit()"
      />
    </div>
  </tp-form>
}
